import Marquee from "react-fast-marquee";

const WORDS = [
  "500+ Wholesale SKUs", "Direct Imports", "Free Edmonton Delivery",
  "Alberta-Wide Shipping", "Price Match & Beat", "Flexible Delivery",
  "One-Stop Supply", "Digital Ordering", "Restaurant-Focused",
];

export default function EditorialMarquee({ tone = "forest" }) {
  const bg = tone === "forest" ? "bg-forest text-butter" : "bg-butter text-forest";
  const dot = tone === "forest" ? "text-butter-deep" : "text-forest";
  return (
    <div data-testid="editorial-marquee" className={`${bg} py-5 border-y border-forest/20 select-none`}>
      <Marquee speed={40} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="mx-8 font-display text-2xl md:text-3xl tracking-tight inline-flex items-center gap-8">
            {w}
            <span className={`${dot} text-xl`}>✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
